var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    stroke: "none",
    color: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.64 20.2044C26.64 19.5663 26.5827 18.9526 26.4764 18.3635H18V21.8449H22.8436C22.635 22.9699 22.0009 23.9231 21.0477 24.5613V26.8194H23.9564C25.6582 25.2526 26.64 22.9453 26.64 20.2044Z",
    fill: "#4285F4",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 29C20.43 29 22.4673 28.1941 23.9564 26.8195L21.0477 24.5613C20.2418 25.1013 19.2109 25.4204 18 25.4204C15.6559 25.4204 13.6718 23.8372 12.9641 21.71H9.95728V24.0418C11.4382 26.9831 14.4818 29 18 29Z",
    fill: "#34A853",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9641 21.7101C12.7841 21.1701 12.6818 20.5933 12.6818 20.0001C12.6818 19.4069 12.7841 18.8301 12.9641 18.2901V15.9583H9.95727C9.34773 17.1733 9 18.5478 9 20.0001C9 21.4523 9.34773 22.8269 9.95727 24.0419L12.9641 21.7101Z",
    fill: "#FBBC05",
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 14.5795C19.3214 14.5795 20.5077 15.0336 21.4405 15.9255L24.0218 13.3441C22.4632 11.8918 20.4259 11 18 11C14.4818 11 11.4382 13.0168 9.95728 15.9582L12.9641 18.29C13.6718 16.1627 15.6559 14.5795 18 14.5795Z",
    fill: "#EA4335",
    stroke: "none"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.3e6fb9429c6277e6f09ec8bc44b64bcb.svg";
export { ForwardRef as ReactComponent };